module.exports={render:function (){
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: ( _obj = {}, _obj[_vm.settingsLinkActiveClass] = ['Autos', 'Auto'].indexOf(_vm.settingLink) + 1, _obj ),
    attrs: {
      "to": {
        name: 'Autos'
      }
    }
  }, [_c('span', [_vm._v("Транспорт")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: ( _obj$1 = {}, _obj$1[_vm.settingsLinkActiveClass] = ['StatusReasons', 'StatusReason'].indexOf(_vm.settingLink) + 1, _obj$1 ),
    attrs: {
      "to": {
        name: 'StatusReasons'
      }
    }
  }, [_c('span', [_vm._v("Признаки статусов заявок")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b20a714","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/menus/SettingsMenu.vue
// module id = 1090
// module chunks = 0